module.exports = __webpack_public_path__ + "static/media/horse-head-helmet-1.94a81be9.glb";